/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import clsx from 'clsx'
//import { isMobileOnly } from 'react-device-detect'

import { useMainSliderStyles } from './main-slider.styles'
import styles from './style.module.scss'
import { Typography, useMediaQuery } from '@material-ui/core'
import { components } from '@plandi/common/src/generated'
import { ProfileCompanyCard } from 'src/features/profile-company/common'
import { ProfileFactoryCard } from 'src/features/profile-factory/common'
import { ProfileSpecialistCard } from 'src/features/profile-specialist/common'
import { TranslationDictionary, theme } from '@plandi/common'
import { useMutationShowSimilar } from 'src/features/profile-specialist/common/profile-specialist-mutations/use-mutation-show-similar'

type itemType =
  | Array<components['schemas']['ProfileSpecialistResource']>
  | Array<components['schemas']['ProfileCompanyResource']>

type SimilarSliderProps = {
  sliderData: itemType | undefined
  title: string
  locale: string
  translate?: TranslationDictionary['data']
  type?: string
}

export const SimilarSlider: React.FC<SimilarSliderProps> = ({
  sliderData,
  title,
  translate,
  locale,
  type
}) => {
  const mutationShowSimilar = useMutationShowSimilar()
  const [showIds, setShowIds] = useState<any>([])
  const [swiperIndex, setSwiperIndex] = useState<number>(0)

  const isDesktopBig = useMediaQuery(theme.breakpoints.up(1500))
  const isDesktop = useMediaQuery(theme.breakpoints.between(800, 1500))
  const isTablet = useMediaQuery(theme.breakpoints.between(450, 800))

  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)
  SwiperCore.use([Navigation, Pagination, Autoplay])

  const classes = useMainSliderStyles()
  const [isShow, setIsShow] = React.useState(false)

  useEffect(() => {
    setIsShow(true)
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIds(
        sliderData &&
          sliderData
            .map((el) => el.id)
            .slice(
              swiperIndex,
              isDesktopBig
                ? swiperIndex + 4
                : isDesktop
                ? swiperIndex + 3
                : isTablet
                ? swiperIndex + 2
                : swiperIndex + 1
            )
      )
    }, 1500)
    return () => clearTimeout(timer)
  }, [isDesktop, isTablet, isDesktopBig, swiperIndex])

  useEffect(() => {
    if (showIds.length !== 0) {
      mutationShowSimilar.mutate(showIds)
    }
  }, [showIds])

  return (
    <>
      {isShow && (
        <div className={classes.root}>
          <Typography className={classes.title}>{title}</Typography>
          <Swiper
            spaceBetween={38}
            className={classes.swiperWrapper}
            slidesPerView={4}
            centerInsufficientSlides={true}
            onActiveIndexChange={({ activeIndex }) => {
              setSwiperIndex(activeIndex)
            }}
            breakpoints={{
              0: {
                slidesPerView: 1
              },
              450: {
                slidesPerView: 2
              },
              800: {
                slidesPerView: 3
              },
              1500: {
                slidesPerView: 4
              }
            }}
            pagination={{
              el: '.bulletWrapper',
              clickable: true,
              renderBullet: (_, className) => {
                return (
                  `<span class="${clsx(className, styles.bullet)}">` + '</span>'
                )
              },
              bulletActiveClass: styles.bulletActive
            }}
            navigation={{
              prevEl: '.prevButton',
              nextEl: '.nextButton'
            }}
          >
            {/* {type === 'company' || type === 'factory'
              ? sliderData?.map((elem, i) => (
                  <SwiperSlide key={i}>
                    <ProfileCompanyCard
                      {...elem}
                      styles={{
                        padding: '26px 0px 26px 0px'
                      }}
                      translate={translate}
                      locale={locale}
                      type={type}
                    />
                  </SwiperSlide>
                ))
              : sliderData?.map((elem, i) => (
                  <SwiperSlide key={i}>
                    <ProfileSpecialistCard
                      {...elem}
                      styles={{
                        padding: '17px 0px 40px'
                      }}
                      translate={translate}
                      locale={locale}
                    />
                  </SwiperSlide>
                ))} */}
            {sliderData?.map((elem, i) => (
              <SwiperSlide key={i}>
                {type === 'factory' && (
                  <ProfileFactoryCard
                    {...elem}
                    styles={{
                      padding: '26px 0px 26px 0px'
                    }}
                    translate={translate}
                    locale={locale}
                    type={type}
                  />
                )}
                {type === 'company' && (
                  <ProfileCompanyCard
                    {...elem}
                    styles={{
                      padding: '26px 0px 26px 0px'
                    }}
                    translate={translate}
                    locale={locale}
                    type={type}
                  />
                )}
                {type !== 'factory' && type !== 'company' && (
                  <ProfileSpecialistCard
                    {...elem}
                    styles={{
                      padding: '17px 0px 40px'
                    }}
                    translate={translate}
                    locale={locale}
                  />
                )}
              </SwiperSlide>
            ))}

            <div className={styles.swiperControlWrapper}>
              <button
                ref={navigationPrevRef}
                className={clsx('prevButton', styles.switchButton)}
              >
                <ArrowRightAltIcon className={styles.switchButtonLeft} />
              </button>
              <div
                className={clsx('bulletWrapper', styles.bulletWrapperCustom)}
              />
              <button
                ref={navigationNextRef}
                className={clsx('nextButton', styles.switchButton)}
              >
                <ArrowRightAltIcon />
              </button>
            </div>
          </Swiper>
        </div>
      )}
    </>
  )
}
